import React from 'react';

import { Box } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';

import { useDocsPanel } from './context';
import { DocsPanel } from './DocsPanel';
import { DocsPanelGuideChip } from './DocsPanelGuideChip';
import { isDocumentationPath } from './utils';

/**
 * Puts the follow-along panel beside the app: the app area narrows (it
 * isn't covered), and keeps its own scrolling. On the docs page itself the
 * full page is already showing, so the panel steps aside.
 */
export const DocsPanelLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const panel = useDocsPanel();
  const { pathname } = useLocation();
  const following =
    panel.state.open && !!panel.state.path && !isDocumentationPath(pathname);
  const showPanel = following && panel.panelFits;
  return (
    <>
      <Box
        position="absolute"
        top={0}
        left={0}
        bottom={0}
        right={showPanel ? `${panel.state.width}px` : 0}
        // The app keeps its minimum width; narrowed, it scrolls sideways in
        // its own area rather than pushing the page under the panel.
        overflowX={showPanel ? 'auto' : undefined}
      >
        {children}
      </Box>
      {showPanel && <DocsPanel />}
      {following && !panel.panelFits && (
        <DocsPanelGuideChip onClick={panel.expand} />
      )}
    </>
  );
};
